import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../style/Footer.css"; // ensure footer styles are applied

const Footer = () => {
  return (
    <footer className="modern-footer">
      <Container fluid className="footer-container">
        <Row className="footer-content">
          <Col className="text-center">
            <div className="footer-divider"></div>
            <span className="footer-text">
              ©Copyright 2025 Gators Transportation. All rights reserved.
            </span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
